// extracted by mini-css-extract-plugin
export default {"recentlyAccessed":"recentbar_recentlyAccessed__zdie8","iconSmall":"recentbar_iconSmall__19nOq","repoBar":"recentbar_repoBar__k9gfU"};